import { useBrokerAgreementSummaryQuery } from '../../queries/brokerAgreementQueries';
import { BrokerAgreementSearchField } from './components/BrokerAgreementSearchField';
import { ClearBrokerAgreementButton } from './components/ClearBrokerAgreementButton';
import { BrokerAgreementCard } from './components/BrokerAgreementCard/BrokerAgreementCard';
import '../../styles/_inputAlignedActions.scss';

interface BorrowerWithBClientProps {
    brokerAgreementId: number | undefined;
    onSelect: (brokerAgreementId: number | undefined) => void;
    disabled: boolean;
    required: boolean;
}

/** "Borrower with B-Client": the B-Client agreement search, and the chosen agreement's details below it. */
export const BorrowerWithBClient = ({ brokerAgreementId, onSelect, disabled, required }: BorrowerWithBClientProps) => {
    const { data: summary } = useBrokerAgreementSummaryQuery(brokerAgreementId);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '4px' }}>
                <div style={{ flex: '1 1 0', minWidth: 0 }}>
                    <BrokerAgreementSearchField
                        value={brokerAgreementId}
                        onChange={onSelect}
                        disabled={disabled}
                        required={required}
                    />
                </div>
                <div className='borrowerSelectorInputAlignedActions'>
                    <ClearBrokerAgreementButton
                        brokerAgreementId={brokerAgreementId}
                        onClear={() => onSelect(undefined)}
                        disabled={disabled}
                    />
                </div>
            </div>
            {summary && (
                <BrokerAgreementCard
                    key={summary.brokerAgreementId}
                    summary={summary}
                />
            )}
        </div>
    );
};
